import classNames from 'classnames'
import Link from 'components/link'
import Image from 'components/image'
import { Media } from 'react-bootstrap'
import css from './category-hero.scss'
import { SectionHeading } from '../../../components/headings'

type TeaserLinkProps = {
  text: string
  url: string
}

export const TeaserLink = ({ text, url }: TeaserLinkProps) => (
  <Link className={css.teaserLink} url={url}>
    {text}
  </Link>
)

type CategoryHeroProps = {
  className?: string
  imageUrl: string
  teaser?: string
  teaserLinkText?: string
  teaserLinkUrl?: string
  title: string
}

const CategoryHero = ({
  className,
  imageUrl,
  teaser,
  teaserLinkText,
  teaserLinkUrl,
  title,
}: CategoryHeroProps) => {
  title = title === 'Holiday Gifts 🎁' ? 'Holiday Gifts' : title
  const placeholderImageSrc =
    'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI3NTAiIGhlaWdodD0iNzUwIiB2aWV3Qm94PSIwIDAgNzUwIDc1MCI+ICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+ICAgICAgICA8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyNDIgMjQyKSI+ICAgICAgICAgICAgPGNpcmNsZSBjeD0iMTMzLjUiIGN5PSIxMzMuNSIgcj0iMTI5IiBzdHJva2U9IiNFNkU2RTYiIHN0cm9rZS13aWR0aD0iOSIvPiAgICAgICAgICAgIDxwYXRoIGZpbGw9IiNFNkU2RTYiIGQ9Ik05MC4xMjkgMTI1LjQyMmMtMS43NDItMTguNDM4IDE0LjU0NC0yOC4wMjYgMjUuNzE2LTI2LjEgOC41NSAxLjQ3MyAxMy4wNyA2LjA3IDE3LjY4IDEwLjUgNC42MDctNC40MyA4LjI5My04LjE0MyAxNy42NzktMTAuNSA5LjE0NC0yLjI5OCAyNy4xNDggNy44NTYgMjUuNzE1IDI2LjEtMS4zNDMgMTcuMS00My4zOTUgNTEuNTc4LTQzLjM5NSA1MS41NzhzLTQxLjMxNy0zMy42ODQtNDMuMzk1LTUxLjU3OCIvPiAgICAgICAgPC9nPiAgICA8L2c+PC9zdmc+'

  const placeholderImage = (
    <Image role="presentation" src={placeholderImageSrc} />
  )

  const heroImageStyles = {
    paddingBottom: '100%',
    backgroundImage: `url(${imageUrl}), url(${placeholderImageSrc})`,
    backgroundSize: 'cover',
  }

  return (
    <div className={className}>
      {imageUrl && (
        <div
          className={classNames(
            'position-rel visible-xs hero-image-background',
            css.mobileImageWrapper
          )}
          style={heroImageStyles}
        />
      )}

      <Media
        className={classNames(css.media, { [css.mediaBordered]: imageUrl })}
      >
        {/* @ts-ignore */}
        <Media.Body className={css.mediaBody}>
          <div className={css.textWrapper}>
            <SectionHeading className={css.title}>{title}</SectionHeading>
            {teaser && (
              <h3
                className={classNames(css.teaser, 'unset-all', {
                  'visible-xs': !imageUrl,
                })}
              >
                {teaser}{' '}
                {teaserLinkUrl && teaserLinkText && (
                  <TeaserLink text={teaserLinkText} url={teaserLinkUrl} />
                )}
              </h3>
            )}
          </div>
        </Media.Body>

        {imageUrl && (
          <Media.Right
            className={classNames('hidden-xs pan position-rel', css.mediaImage)}
          >
            {placeholderImage}
            <Image
              alt={title}
              className={css.absoluteImage}
              lazyLoad={false}
              src={imageUrl}
            />
          </Media.Right>
        )}
      </Media>
    </div>
  )
}

export default CategoryHero
